import { WaTableSkeleton } from "../../../../pages/whatsapp/components/skeletons/WhatsAppPageSkeletons";

export const LoadingState = () => <WaTableSkeleton rows={5} cols={4} />;
